module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("This work consists of images from the Local History Collection of the Sterling Heights Public Library, including donations from residents, photographs taken by employees of Sterling Township and the City of Sterling Heights, and a collection of photographs from the “morgue” of the defunct Utica Sentinel. We would like to recognize the generosity of residents Eleanor Ahrens, the Backus family, Helen Cope Beuthin, Jim Boehmer, Barney Calka, Barbara Faust Counsell, Marjorie Upton DeFrancis, Wally Doebler, the Fulk family, Jeanette Glawe, Rose Bower Hacker, Lawrence Haff, Irene Holzhauer Hoffman, Elmer Measel, Eddie Nowalski, Evelyn Vogler Nowalski, Edward Ochylski Jr., Merle Drake Peters, the Ernest Pruehs family, Cheryl Wilbrett Snay, Lois Fischer Stone, Kristen Trimakas, John Urquart, and particularly Duane Kleino, Ferry Schoonover, F. James Dunlop, and Jerry Sieja for their generous donations of photographs, time, research, and support.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Thanks also to my coworkers and to the staff at the Sterling Heights Public Library, particularly Carol Lingeman and Joe Vitale, whose patience and assistance are unmatched.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The collection of the Sterling Heights Public Library, particularly their oral history interviews and access to the Ancestry Plus database, made this project much easier and more enjoyable.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Special thanks to my family, Chuck, Allison, and Lauren, for putting up with my research addictions and to Ruth Baker, local history expert and retired librarian, who years ago gave me a solid start in my research on the area and whose interests and enthusiasms I share.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-d"
  }, [_c('span', [_vm._v("—Debra Vercellone")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439632802_i0003.jpg",
      "src": "images/e9781439632802_i0003.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE AUTHORS.")]), _vm._v(" For this volume, Debra Vercellone wrote the captions on behalf of the Sterling Heights Public Library. Wallace Doebler wrote the introduction on behalf of the Sterling Heights Historical Commission.")])])])])])]), _c('a', {
    attrs: {
      "id": "title1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15217c20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439632802_ack01.vue
// module id = 72
// module chunks = 0